import {
  readonly,
  ref,
  useContext
} from "@nuxtjs/composition-api";
import { Logger } from "@wemade-vsf/core";
function useForgotPassword() {
  const { app } = useContext();
  const loading = ref(false);
  const result = ref({
    resetPasswordResult: null,
    setNewPasswordResult: null
  });
  const error = ref({
    request: null,
    setNew: null
  });
  const resetPassword = async (resetPasswordParams) => {
    var _a, _b;
    Logger.debug("useForgotPassword/request", resetPasswordParams.email);
    try {
      loading.value = true;
      Logger.debug("[Magento]: Reset user password", resetPasswordParams);
      const { data } = await app.context.$vsf.$magento.api.requestPasswordResetEmail({ email: resetPasswordParams.email, recaptchaToken: resetPasswordParams.recaptchaToken }, (_a = resetPasswordParams == null ? void 0 : resetPasswordParams.customQuery) != null ? _a : null, resetPasswordParams == null ? void 0 : resetPasswordParams.customHeaders);
      Logger.debug("[Result]:", { data });
      error.value.request = data;
      result.value.resetPasswordResult = (_b = data == null ? void 0 : data.requestPasswordResetEmail) != null ? _b : false;
    } catch (err) {
      error.value.request = err;
      Logger.error("useForgotPassword/request", err);
    } finally {
      loading.value = false;
    }
  };
  const setNewPassword = async (setNewPasswordParams) => {
    var _a, _b;
    Logger.debug("useForgotPassword/setNew", setNewPasswordParams);
    try {
      loading.value = true;
      const { data } = await app.context.$vsf.$magento.api.resetPassword({
        email: setNewPasswordParams.email,
        newPassword: setNewPasswordParams.newPassword,
        resetPasswordToken: setNewPasswordParams.tokenValue,
        recaptchaToken: setNewPasswordParams.recaptchaToken
      }, (_a = setNewPasswordParams == null ? void 0 : setNewPasswordParams.customQuery) != null ? _a : null, setNewPasswordParams == null ? void 0 : setNewPasswordParams.customHeaders);
      Logger.debug("[Result]:", { data });
      result.value.setNewPasswordResult = (_b = data == null ? void 0 : data.resetPassword) != null ? _b : false;
      error.value.setNew = null;
    } catch (err) {
      error.value.setNew = err;
      Logger.error("useForgotPassword/setNew", err);
    } finally {
      loading.value = false;
    }
  };
  return {
    request: resetPassword,
    setNew: setNewPassword,
    loading: readonly(loading),
    result: readonly(result),
    error: readonly(error)
  };
}
export * from "./useForgotPassword";
var useForgotPassword_default = useForgotPassword;
export {
  useForgotPassword_default as default,
  useForgotPassword
};
